/* RICHGALLI — theme.js */
document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav */
  const mobBtn   = document.getElementById('mob-nav-btn');
  const mobClose = document.getElementById('mob-nav-close');
  const mobNav   = document.getElementById('mob-nav');
  if (mobBtn)   mobBtn.addEventListener('click',  () => { mobNav.classList.add('open'); document.body.style.overflow='hidden'; });
  if (mobClose) mobClose.addEventListener('click', () => { mobNav.classList.remove('open'); document.body.style.overflow=''; });

  /* Cart drawer */
  function openCart()  { document.getElementById('cart-overlay').classList.add('open'); document.getElementById('cart-drawer').classList.add('open'); document.body.style.overflow='hidden'; refreshCart(); }
  function closeCart() { document.getElementById('cart-overlay').classList.remove('open'); document.getElementById('cart-drawer').classList.remove('open'); document.body.style.overflow=''; }
  const cartBtn     = document.getElementById('cart-btn');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-close');
  if (cartBtn)     cartBtn.addEventListener('click', openCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);

  /* Refresh cart UI */
  async function refreshCart() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = data.item_count;
      const subEl = document.getElementById('cart-sub');
      if (subEl) subEl.textContent = formatMoney(data.total_price);
      const bodyEl = document.getElementById('cart-body');
      if (!bodyEl) return;
      if (data.item_count === 0) {
        bodyEl.innerHTML = '<p class="cart-drawer__empty">your bag is empty</p>';
        return;
      }
      bodyEl.innerHTML = data.items.map(item => `
        <div style="display:grid;grid-template-columns:60px 1fr;gap:14px;margin-bottom:18px;padding-bottom:18px;border-bottom:1px solid var(--border);">
          <a href="${item.url}"><img src="${item.image}" style="width:60px;height:76px;object-fit:cover;background:var(--beige);" alt="${item.title}"></a>
          <div>
            <p style="font-family:var(--font-head);font-size:11px;letter-spacing:0.06em;text-transform:lowercase;color:var(--charcoal);margin-bottom:3px;">${item.product_title.toLowerCase()}</p>
            ${item.variant_title !== 'Default Title' ? `<p style="font-family:var(--font-head);font-size:10px;color:var(--muted);letter-spacing:0.08em;text-transform:uppercase;margin-bottom:5px;">${item.variant_title}</p>` : ''}
            <div style="display:flex;justify-content:space-between;align-items:center;">
              <span style="font-family:var(--font-head);font-size:11px;color:var(--charcoal);">${formatMoney(item.final_price)}</span>
              <a href="/cart/change?id=${item.key}&quantity=0" style="font-family:var(--font-head);font-size:9px;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted);border-bottom:1px solid var(--border);">remove</a>
            </div>
          </div>
        </div>`).join('');
    } catch(e) { console.warn('Cart refresh error:', e); }
  }

  function formatMoney(cents) { return '£' + (cents/100).toFixed(2); }

  /* Quick add */
  window.quickAdd = async function(e, id) {
    e.preventDefault(); e.stopPropagation();
    const btn = e.currentTarget;
    const orig = btn.textContent;
    btn.textContent = 'adding...'; btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id, quantity:1}) });
      if (res.ok) { btn.textContent = 'added ✓'; await refreshCart(); setTimeout(openCart, 300); }
      else { btn.textContent = 'select size on page'; }
    } catch(e) { btn.textContent = 'error'; }
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2200);
  };

  /* Product page ATC */
  const prodForm = document.getElementById('prod-form');
  if (prodForm) {
    prodForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const btn = document.getElementById('atc-btn');
      const orig = btn.textContent;
      btn.textContent = 'adding...'; btn.disabled = true;
      const fd = new FormData(prodForm);
      try {
        const res = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: fd.get('id'), quantity: fd.get('quantity') || 1}) });
        if (res.ok) { btn.textContent = 'added to bag ✓'; await refreshCart(); setTimeout(openCart, 400); }
        else { btn.textContent = 'please select a size'; }
      } catch(e) { btn.textContent = 'error — try again'; }
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2500);
    });
  }

  /* Product gallery thumbs */
  window.switchImg = function(src) {
    const main = document.getElementById('main-img');
    if (main) main.src = src;
    document.querySelectorAll('.prod-pg__thumb').forEach(t => t.classList.remove('active'));
  };

  /* Size selection */
  window.selectSize = function(btn) {
    document.querySelectorAll('.size-opt').forEach(b => b.classList.remove('sel'));
    btn.classList.add('sel');
    document.getElementById('variant-id').value = btn.dataset.variantId;
    const priceEl = document.getElementById('pg-price');
    if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
  };

  refreshCart();
});
